
import Vue from 'vue'
import Component from 'vue-class-component'
import { namespace } from 'vuex-class'
import { getModule } from 'vuex-module-decorators';

import { Tag, arrayFromMap, FullTag } from '@/lib'
import JapaneseModule from '@/store/modules/japanese'
const japanese = namespace('japanese')

const Props = Vue.extend({
  props: {
    parentTagID: String,
  },
})

@Component({
  name: 'TagManagement',
})
export default class TagSelection extends Props {
  @japanese.Action
  createTag!: () => Promise<void>

  @japanese.Action
  updateTag!: () => Promise<void>

  /* eslint-disable no-unused-vars */
  @japanese.Mutation
  editTag!: (label: FullTag) => Promise<void>

  @japanese.Action
  removeTag!: (label: FullTag) => Promise<void>
  /* eslint-enable no-unused-vars */

  get tags(): Record<string, Tag> {
    const module = getModule(JapaneseModule, this.$store);
    return module.tags
  }

  get tagCreating(): string {
    const module = getModule(JapaneseModule, this.$store);
    return module.tagCreating
  }

  set tagCreating(value: string) {
    const module = getModule(JapaneseModule, this.$store);
    module.setTagCreating(value)
  }

  get isEditingTag(): boolean {
    const module = getModule(JapaneseModule, this.$store);
    return module.isEditingTag
  }

  get tagEditing(): Tag {
    const module = getModule(JapaneseModule, this.$store);
    return module.tagEditing
  }

  arrayFromMap (m: Record<string, unknown>): unknown[] {
    return arrayFromMap(m)
  }

  parentTagsOnly (m: Record<string, Tag>): Record<string, FullTag> {
    const n: Record<string, FullTag> = {}

    for (const tagID in m) {
      const tag = m[tagID]
      const fullTag: FullTag = {
        _id: tag._id,
        type: tag.type,
        name: tag.name,
        children: tag.children.map((childTag: string) => this.tags[childTag]),
        parentID: tag.parentID,
      }
      if (tag.parentID === this.parentTagID) {
        n[tagID] = fullTag
      }
    }

    return n
  }
}
